import Login from "./views/shared/Login.jsx";
import TrocarSenha from "./views/admin/seguranca/TrocarSenha.jsx";
import EsqueceuSenha from "./views/shared/EsqueceuSenha";

import DashBoard from "./views/admin/DashBoard.jsx";
import Home from "./views/admin/Home.jsx";

import OrdemColetaList from "./views/admin/coleta/OrdemColetaList.jsx";
import PlanosColetaList from "./views/admin/coleta/PlanosColetaList.jsx";
import PontosColetaList from "./views/admin/coleta/PontosColetaList.jsx";
import VeiculosList from "./views/admin/cadastros/VeiculosList.jsx";
import JustificativaList from "./views/admin/cadastros/JustificativaList.jsx";
import UsuariosList from "./views/admin/seguranca/UsuariosList.jsx";
import AnaliseOrdemColetaList from "./views/admin/avaliacao-os/AnaliseOrdemColetaList";
import AnaliseOrdemColetaMap from "./views/admin/avaliacao-os/AnaliseOrdemColetaMap";
import OrdemColetaPesquisa from "./views/admin/coleta/OrdemColetaPesquisa";
import Monitoramento from "./views/admin/monitoramento/Monitoramento";
import MonitoramentoTV from "./views/admin/monitoramento/MonitoramentoTV";
import DestinosList from "./views/admin/cadastros/DestinosList.jsx";
import DownloadAPP from "./views/admin/DownloadAPP";
import DelimitacaoGeograficaSetoresList from "./views/admin/cadastros/DelimitacaoGeograficaSetoresList.jsx";
import HistoricoList from "./views/admin/historico/HistoricoList.jsx";

//Relatorios
import ProdutividadeAnalitico from "./views/admin/Relatorios/ProdutividadeAnalitico/index.jsx";
import ProdutividadeSintetico from "./views/admin/Relatorios/ProdutividadeSintetico/index.jsx";
import Inconformidades from "./views/admin/Relatorios/Inconformidades/index.jsx";
import Ocorrencias from "./views/admin/Relatorios/Ocorrencias/index.jsx";
import AtendimentoAnalitico from "./views/admin/Relatorios/AtendimentoAnalitico/index.jsx";
import AtendimentoSintetico from "./views/admin/Relatorios/AtendimentoSintetico/index.jsx";
import QualidadeAnalitico from "./views/admin/Relatorios/QualidadeAnalitico/index.jsx";
import QualidadeSintetico from "./views/admin/Relatorios/QualidadeSintetico/index.jsx";
import Relatorios from "./views/admin/Relatorios/Relatorios.jsx";
import HistoricoAtendimentoPontoColeta from "views/admin/Relatorios/HistoricoAtendimentoPontoColeta/index.jsx";

import { faChartSimple, faMagnifyingGlass, faTv, faFileSignature, faMapLocationDot, faTruck, faTruckRampBox, faHandPointRight, faFile,
  faUser, faLocationDot, faListCheck, faDownload,
  faHome
 } from '@fortawesome/free-solid-svg-icons';

var routes = [
  {
    path: "/login",
    name: "Login",
    icon: "",
    component: Login,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/esqueceusenha",
    name: "EsqueceuSenha",
    icon: "",
    component: EsqueceuSenha,
    layout: "/auth",
    sidebar: false
  },
  {
    path: "/home",
    name: "Home",
    icon: faHome,
    component: Home,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: faChartSimple,
    component: DashBoard,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/monitoramento",
    name: "Monitoramento",
    icon: faTv,
    component: Monitoramento,
    layout: "/mapaordem",
    sidebar: true
  },
  {
    path: "/programacao",
    name: "Programação de Serviço",
    icon: faListCheck,
    component: OrdemColetaList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/ordemserviçopesquisa",
    name: "Pesquisa de Ordens",
    icon: faMagnifyingGlass,
    component: OrdemColetaPesquisa,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/historico",
    name: "Histórico de Execução",
    icon: faFileSignature,
    component: HistoricoList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/planostrabalho",
    name: "Planos de Trabalho",
    icon: faLocationDot,
    component: PlanosColetaList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/delimitacaoGeografica",
    name: "Delimitação Geografica",
    icon: faMapLocationDot,
    component: DelimitacaoGeograficaSetoresList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/destino",
    name: "Destinos",
    icon: faTruckRampBox,
    component: DestinosList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/localexecucao",
    name: "Locais de Execução",
    icon: faLocationDot,
    component: PontosColetaList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/recursos",
    name: "Recursos",
    icon: faTruck,
    component: VeiculosList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/justificativa",
    name: "Justificativas",
    icon: faHandPointRight,
    component: JustificativaList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/usuarios",
    name: "Usuários",
    icon: faUser,
    component: UsuariosList,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/relatorios",
    name: "Relatórios",  
    icon: faFile,
    component: Relatorios,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/downloadapp",
    name: "Download Aplicativo",
    icon: faDownload,
    component: DownloadAPP,
    layout: "/concessionaria",
    sidebar: true
  },
  {
    path: "/monitoramentoTV",
    name: "Monitoramento TV",
    component: MonitoramentoTV,
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/analiseordem",
    name: "Análise de Ordem de Serviço",
    component: AnaliseOrdemColetaList,
    layout: "/concessionaria",
    sidebar: false
  },
  {
    path: "/analiseordemmap",
    name: "Mapa de Ordem de Serviço",
    component: AnaliseOrdemColetaMap,
    layout: "/mapaordem",
    sidebar: false
  },
  {
    path: "/trocarsenha",
    name: "Trocar Senha",
    icon: "",
    component: TrocarSenha,
    layout: "/concessionaria",
    sidebar: false
  },
  {
    path: "/relatorio/ProdutividadeAnalitico",
    name: "Relatório de Produtividade Analítico",    
    component: ProdutividadeAnalitico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/ProdutividadeSintetico",
    name: "Relatório de Produtividade Sintético",    
    component: ProdutividadeSintetico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/Inconformidades",
    name: "Relatório de Inconformidades",    
    component: Inconformidades,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/Ocorrencias",
    name: "Relatório de Ocorrências",    
    component: Ocorrencias,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/AtendimentoAnalitico",
    name: "Relatório de Atendimento Analítico",    
    component: AtendimentoAnalitico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/AtendimentoSintetico",
    name: "Relatório de Atendimento Sintético",    
    component: AtendimentoSintetico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/QualidadeAnalitico",
    name: "Relatório de Qualidade Analítico",    
    component: QualidadeAnalitico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/QualidadeSintetico",
    name: "Relatório de Qualidade Sintético",    
    component: QualidadeSintetico,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
  {
    path: "/relatorio/HistoricoAtendimentoPontoColeta",
    name: "Relatório de Histórico de Atendimento dos Pontos de Coleta",    
    component: HistoricoAtendimentoPontoColeta,
    layout: "/concessionaria",
    sidebar: false,
    relatorio: true
  },
];

export default routes;
